import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { FC, useCallback, useMemo, useState } from 'react'
import * as _ from 'lodash'
import type { IUser } from '@user/store/authorization/typings'

import { App } from './App'
import { analytics, helpAndSupport } from './constants'

import AppsIcon from '@mui/icons-material/Apps'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Popover from '@mui/material/Popover'
import { useCheckPermissions } from '@user/store/authorization'

interface Props {
  user: IUser
}

export const AppSwitcher: FC<Props> = (props) => {
  const { user } = props

  const [hasReportPermission] = useCheckPermissions('reports_view')

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)
  const id = open ? 'add-popover' : undefined

  const onClose = useCallback(() => setAnchorEl(null), [])
  const onOpen = useCallback(
    (e: React.MouseEvent<HTMLElement>) => setAnchorEl(e.currentTarget),
    [],
  )

  const apps = useMemo(() => {
    const apps = user.externalApplications.filter(
      (app) => app.name != 'Lead Management',
    )

    apps.push(helpAndSupport)

    if (hasReportPermission) apps.push(analytics)

    return _.sortBy(apps, ['name'])
  }, [hasReportPermission, user.externalApplications])
  const theme = useTheme()
  return (
    <>
      <Button
        color="primary"
        disableRipple
        variant={open ? 'contained' : 'outlined'}
        onClick={onOpen}
        data-test-id="appSwitchBtn"
        sx={{
          height: '47px',
          minWidth: '47px',
          padding: theme.spacing(1),
        }}
      >
        <AppsIcon color="inherit" />
      </Button>
      <Popover
        id={id}
        open={open}
        onClose={onClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: -5,
          horizontal: 'right',
        }}
        PaperProps={{ onMouseLeave: onClose, elevation: 3 }}
      >
        <Box display="flex">
          {apps &&
            apps.map((app) => <App key={app.id} app={app} onClose={onClose} />)}
        </Box>
      </Popover>
    </>
  )
}

AppSwitcher.displayName = 'AppSwitcher'
